<template>
  <div class="dashboard">
    <!-- Grid List on the Left -->
    <div class="grid-list">
      <input type="text" v-model="searchQuery" placeholder="搜索..." class="search-bar"/>

      <ul>
        <li v-for="grid in filteredGrids" :key="String(grid.ID)" @click="selectGrid(grid)">
          <span>{{ grid.GridName }}</span> </br>
          <span v-if="grid.InWorld" class="in-world-tag">在线</span>
          <span v-else class="out-world-tag">下线</span>
          <span class="owner-tag">{{ grid.Ownership }}</span>
          <span class="server-tag">{{ grid.ServerName }}</span> | 
          <span>格子数: {{ grid.BlockCount }}</span>
        </li>
      </ul>
    </div>

    <!-- Grid Details on the Right -->
    <div class="grid-details">
      <GridDetail v-if="selectedGrid" :ownerid="selectedGrid.OwnerID.toString()" :gridname="selectedGrid.GridName" />
    </div>
  </div>
</template>

<script>
import axios from '../api/axios';
import GridDetail from './GridDetail.vue';

export default {
  components: {
    GridDetail
  },
  props: {
    ownerid: {
      type: String,
      default: null
    },
    gridname: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      grids: [],
      selectedGrid: null,
      searchQuery: ''
    };
  },
  watch: {
    '$route.params': {
      handler(newParams) {
        this.updateSelectedGrid(newParams.ownerid, newParams.gridname);
      },
      immediate: true
    }
  },
  methods: {
    fetchGrids() {
      axios.get('/allgrids')
        .then(response => {
          this.grids = response.data.map(grid => {
            return {
              ...grid,
              GridID: BigInt(grid.GridID),
              OwnerID: BigInt(grid.OwnerID),
            };
          });
          if (!this.$route.params.ownerid && !this.$route.params.gridname && this.grids.length > 0) {
            const firstGrid = this.grids[0];
            this.$router.replace({ name: 'AllGridsWithDetails', params: { ownerid: firstGrid.OwnerID.toString(), gridname: firstGrid.GridName } });
          } else {
            this.updateSelectedGrid(this.$route.params.ownerid, this.$route.params.gridname);
          }
        })
        .catch(error => {
          console.error('获取网格数据时出错:', error);
        });
    },
    updateSelectedGrid(ownerid, gridname) {
      if (ownerid && gridname) {
        this.selectedGrid = this.grids.find(grid => grid.OwnerID.toString() === ownerid && grid.GridName === gridname);
      } else {
        this.selectedGrid = null;
      }
    },
    selectGrid(grid) {
      const currentRoute = this.$route;
      if (currentRoute.params.ownerid !== grid.OwnerID.toString() || currentRoute.params.gridname !== grid.GridName) {
        this.$router.push({ name: 'AllGridsWithDetails', params: { ownerid: grid.OwnerID.toString(), gridname: grid.GridName } });
        console.log('Selected grid:', grid);
      }
    }
  },
  mounted() {
    this.fetchGrids();
  },
  computed: {
    filteredGrids() {
      if (!this.searchQuery) {
        return this.grids;
      }
      return this.grids.filter(grid => {
        if(!grid || !grid.GridName) return false;
        return grid.GridName.toLowerCase().includes(this.searchQuery.toLowerCase());
      });
    }
  },
};
</script>

<style scoped>
.dashboard {
  display: flex;
  justify-content: space-between;
  /* background-color: #2A2A2A; */
  color: #FFFFFF;
}

.grid-list {
  margin-top:50px;
  position: fixed;
  width: 400px;
  /* background-color: #1F1F1F; */
  padding: 20px;
  height: 100vh;
  overflow-y: auto;
  border-right: 1px solid #444;
}

.grid-details {
  width: 100%;
  padding: 20px 20px 20px 400px;
}

.list-title {
  color: #FFFFFF;
  text-align: center;
  font-size: 24px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  padding: 10px;
  border-bottom: 1px solid #444;
  cursor: pointer;
  color: white;
}

li:hover {
  background-color: #555;
}

.owner-tag {
  background-color: rgb(18, 181, 214);
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 5px;
}
.search-bar {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #444;
  background-color: #333;
  color: white;
}
.server-tag{
  background-color: rgba(142, 1, 152, 0.6);
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 5px;
}
.in-world-tag {
  background-color: rgba(10, 252, 39, 0.6);
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 5px;
}

.out-world-tag {
  background-color: rgba(135, 135, 135, 0.6);
  padding: 2px 5px;
  border-radius: 5px;
  margin-right: 5px;
}
</style>
